import { Component, Host, h, Element, Prop, Event, EventEmitter, Watch, JSX } from '@stencil/core';
import { remCalc } from '../../style';

export enum ModalAlignment {
  CENTER,
  TOP,
  BOTTOM,
}

@Component({
  tag: 'rcm-modal',
  styleUrl: 'rcm-modal.scss',
  shadow: true,
})
export class RcmModal {
  @Element() el: HTMLElement;

  /** Controls visibility of component */
  @Prop({ mutable: true }) show = false;

  /** Hide or show close icon */
  @Prop() withCloseIcon = false;

  /** With or without Padding */
  @Prop() padding = '1rem';

  /** Fullscreen or taking up the space it needs */
  @Prop() fullscreen = false;

  /** Taking up full width of the screen */
  @Prop() fullWidth = false;

  /** Show navigation and search when fullscreen */
  @Prop() withSearch = false;

  /** Is modal scrollable */
  @Prop() scrollable = true;

  /** Background color */
  @Prop() backgroundColor: string;

  @Prop() minWidth: string;

  @Prop() alignment: ModalAlignment = ModalAlignment.CENTER;

  @Event({ eventName: 'rcmModalShowToggle' }) rcmModalShow: EventEmitter<boolean>;

  @Event({ eventName: 'eventt' }) eventNamee: EventEmitter;

  @Watch('show')
  showHandler(value: boolean): void {
    this.rcmModalShow.emit(value);
    if (this.show) {
      document.body.classList.add('body--overflow-hidden');
    } else {
      document.body.classList.remove('body--overflow-hidden');
    }
  }

  private handleCloseClick = () => {
    this.show = false;
  };

  render(): JSX.Element {
    return (
      <Host>
        <div
          class={{
            overlay: true,
            open: this.show,
            'with-search': this.withSearch,
            top: this.alignment === ModalAlignment.TOP,
            bottom: this.alignment === ModalAlignment.BOTTOM,
          }}
        >
          <div
            class={{ 'modal-window': true, fullscreen: this.fullscreen }}
            style={{
              padding: this.fullscreen && this.padding,
              display: this.scrollable && 'flex',
              background: this.backgroundColor ?? 'var(--colors-basic-white)',
              minWidth: this.minWidth ?? `${remCalc(350)}rem`,
              maxWidth: (!this.fullWidth && !this.fullscreen && `${remCalc(650)}rem`) || null,
              width: (this.fullWidth && '100%') || null,
            }}
          >
            <div class={{ 'modal-window__scroll-container': this.scrollable }} style={{ padding: !this.fullscreen && this.padding }}>
              <div class="modal-window__content">
                <slot />
              </div>
            </div>
            {this.withCloseIcon ? (
              <div class="close" onClick={this.handleCloseClick}>
                <rcm-icon icon="x" color="var(--colors-basic-white)" height={`${remCalc(18)}rem`} />
              </div>
            ) : null}
          </div>
        </div>
      </Host>
    );
  }
}
